import * as PropTypes from "prop-types";
import React, {useEffect, useState} from "react";
import EAButton from "../../EAButton";
import {logger} from "../../../services/LogService";
import {useHttpSortById} from "../../../utils/usePreformattedHttp";
import {AufnahmeTableDialog} from "./AnlagenEinleiter";
import {
    getDrosselablaufAnlagen, getDrosselablaufAnlagenForBetrieb
} from "../../../services/AnlagenService";
import EADialog from "../../EADialog";
import EATextField from "../../EATextField";
import EATable from "../../EATable";
import {createCalculatedColumn, createColumn, createComponentColumn} from "../../../utils/ColumnUtils";
import {Checkbox, FormControlLabel, Grid} from "@material-ui/core";
import EATableActionButton from "../../tableComponents/EATableActionButton";
import EAButtonBar from "../../EAButtonBar";

function DrosselablaufTableDialog(props) {
    const [getAllAnlagen, setGetAllAnlagen] = useState(false);
    const [filteredData, setFilteredData] = useState([]);
    const [filter, setFilter] = useState("");

    let [{data, loading}, refetchData] = useHttpSortById({
        url: getDrosselablauf(getAllAnlagen),
        timeout: 6000000,
    });

    function getDrosselablauf(getAllAnlagen) {
        if (getAllAnlagen) {
            return getDrosselablaufAnlagen(props.anlagenart);
        }
        return getDrosselablaufAnlagenForBetrieb(props.betriebsId, props.anlagenart);
    }

    useEffect(() => {
        if (data) {
            setFilteredData([
                ...data.filter((item) => {
                    return (
                        item.id !== props.anlageId &&
                        (!filter ||
                            item.betrieb.value.toLowerCase().includes(filter.toLowerCase()) ||
                            item.gemarkung.toLowerCase().includes(filter.toLowerCase()) ||
                            item.bezeichnung.toLowerCase().includes(filter.toLowerCase()))
                    );
                }),
            ]);
        }
    }, [data, props.anlageId, filter, loading]);

    const handleChange = () => {
        setGetAllAnlagen(!getAllAnlagen);
        refetchData();
    };

    return (
        <EADialog
            open={props.open}
            titleChildren={"Misch-/Niederschlagswasseranlage auswählen"}
            content={
                <div style={{width: "700px", maxHeight: "520px", minHeight: "400px"}}>
                    <div className="gridl" style={{gridTemplateColumns: "repeat(3,auto)", paddingBottom: "8px"}}>
                        <EATextField
                            value={filter}
                            onChange={(e) => {
                                e.preventDefault();
                                setFilter(e.target.value);
                            }}
                            id="drosselablaufFilter"
                            data-cy="drosselablaufFilter"
                            label="Suchkriterium"
                        />
                        <div>
                            <EAButton
                                onClick={() => {
                                    setFilter("");
                                }}
                                id="drosselablaufFilterSucheReset"
                                data-cy="drosselablaufFilterSucheReset"
                                label="Zurücksetzen"
                            />
                        </div>
                        <FormControlLabel
                            label="Anlagen aller Betriebe anzeigen"
                            control={
                                <Checkbox
                                    value={getAllAnlagen}
                                    onChange={handleChange}
                                />
                            }
                        />
                    </div>
                    <EATable
                        id="drosselablaufAuswahl"
                        initialSortColumn="mipNr"
                        columns={[
                            createComponentColumn(
                                "actions",
                                (row, index) => {
                                    return (
                                        <Grid container spacing={1} justify="center">
                                            <Grid item>
                                                <EATableActionButton id={"selectDrosselablauf-" + index} iconName="ico-check">
                                                    <span
                                                        onClick={() => {
                                                            setFilter("");
                                                            props.onClickOk(row);
                                                        }}
                                                        className={"w-100"}
                                                        style={{
                                                            height: "100%",
                                                            display: "block",
                                                        }}
                                                    />
                                                </EATableActionButton>
                                            </Grid>
                                        </Grid>
                                    );
                                },
                                "",
                                null,
                                {width: "50px", padding: "0"}
                            ),
                            createCalculatedColumn(
                                "betrieb",
                                (row) => {
                                    return row.betrieb.value;
                                },
                                "Betrieb"
                            ),
                            createColumn("gemarkung", "Gemarkung"),
                            createColumn("bezeichnung", "Abwasseranlage"),
                        ]}
                        data={filteredData}
                        loading={!data || loading}
                    />
                </div>
            }
            buttons={
                <EAButtonBar>
                    <EAButton id={"btnAbbrechen"} data-cy={"btnAbbrechen"} label={"Abbrechen"} onClick={props.onClickCancel}/>
                </EAButtonBar>
            }
            closeFunction={props.onClickCancel}
        />
    );
}

DrosselablaufTableDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    onClickCancel: PropTypes.func.isRequired,
    onClickOk: PropTypes.func.isRequired,
};

export function EntlastungsanlagenEinleiter({
                                     onChange,
                                     betriebsId,
                                     anlageId,
                                     anlagentyp,
                                     anlagenart,
                                     formFactory,
                                     isButtonVisible,
                                 }) {
    const dataNameAufnahme = "aufnahme";
    const dataNameDrosselablauf = "drosselablauf";
    const [aufnahmeDlgOpen, setAufnahmeDlgOpen] = useState(false);
    const [drosselablaufDlgOpen, setDrosselablaufDlgOpen] = useState(false);

    function handleCloseAufnahme() {
        setAufnahmeDlgOpen(false);
    }

    function handleCloseAufnahmeOk(anlage) {
        setAufnahmeDlgOpen(false);
        logger.debug(dataNameAufnahme + "Close", anlage);
        anlage.value = anlage.bezeichnung;
        onChange(dataNameAufnahme, anlage);
    }

    function handleCloseDrosselablauf() {
        setDrosselablaufDlgOpen(false);
    }

    function handleCloseDrosselablaufOk(anlage) {
        setDrosselablaufDlgOpen(false);
        logger.debug(dataNameDrosselablauf + "Close", anlage);
        anlage.value = anlage.bezeichnung;
        onChange(dataNameDrosselablauf, anlage);
    }

    return (
        <>
            {aufnahmeDlgOpen && (
                <AufnahmeTableDialog
                    open={aufnahmeDlgOpen}
                    onClickCancel={handleCloseAufnahme}
                    onClickOk={handleCloseAufnahmeOk}
                    betriebsId={betriebsId}
                    anlageId={anlageId}
                    anlagentyp={anlagentyp}
                />
            )}
            {drosselablaufDlgOpen && (
                <DrosselablaufTableDialog
                    open={drosselablaufDlgOpen}
                    onClickCancel={handleCloseDrosselablauf}
                    onClickOk={handleCloseDrosselablaufOk}
                    betriebsId={betriebsId}
                    anlageId={anlageId}
                    anlagentyp={anlagentyp}
                    anlagenart={anlagenart}
                />
            )}
            <div className="gridl gridForAnlagenEinleiter" style={{padding: "var(--vertical-spacing) 0 0"}}>
                <div className="gridl" style={{gridTemplateColumns: "1fr auto"}}>
                    {formFactory.renderInput("aufnahme.value", "aufnahme.value", "Aufnehmende Anlage", "text", true)}
                    {isButtonVisible &&
                        formFactory.renderButton("aufnameAendern", "aufnameAendern", "auswählen...", () => setAufnahmeDlgOpen(true), {
                            "data-cy": "aufnameAendern",
                        })}
                </div>
                <div className="gridl" style={{gridTemplateColumns: "1fr auto"}}>
                    {formFactory.renderInput("drosselablauf.value", "drosselablauf.value", "Drosselablauf in Bauwerk", "text", true)}
                    {isButtonVisible &&
                        formFactory.renderButton("drosselablaufAendern", "drosselablaufAendern", "auswählen...", () => setDrosselablaufDlgOpen(true), {
                            "data-cy": "drosselablaufAendern",
                        })}
                </div>
            </div>
            {formFactory.renderError("aufnahme", "aufnahme", "", "Es muss eine aufnehmende Anlage ausgewählt werden")}
        </>
    );
}

EntlastungsanlagenEinleiter.propTypes = {
    betriebsId: PropTypes.any.isRequired,
    anlagentyp: PropTypes.string.isRequired,
    formFactory: PropTypes.any.isRequired,
    disabled: PropTypes.any.isRequired,
    isButtonVisible: PropTypes.bool.isRequired,
    isIndirektDisabled: PropTypes.bool,
};
